<template>
    <el-dialog class="middleDialog" :visible.sync="visible" :close-on-click-modal="false" top="auto" width="1400px">
        <div class="card">
            <!-- <div class="userInfoHeaderImg" v-if="userInfo.coverUrl">
                <i class="el-dialog__close el-icon el-icon-close absolute right-0 mr-30 mt-30 color-fff fs-30 bold"
                    @click="closeClick"></i>
                <img class="w100 h100 br-t-28" style="object-fit: cover;" :src="userInfo.coverUrl"></img>
            </div> -->
            <div class="userInfo">
                <div class="everyInfo">
                    <div class="avatarInfo">
                        <div class="left">
                            <div class="avatarAndStatus">
                                <img class="avatar"
                                    :src="userInfo.avatar_large ? userInfo.avatar_large : require('@/assets/profile.png')"
                                    alt="">
                                <div :class="['icon', userInfo.is_online ? '' : 'offline']"></div>
                            </div>
                            <div class="nameInfo">
                                <div class="top">
                                    <div class="info_title">
                                        <div class="name flex row middle">
                                            <!-- <img :class="'w-24 h-24 mr-4 ' + (userInfo?.confirmed ? '' : 'img_gray')"
                                                src="@/assets/confirmed.png" alt=""> -->
                                            {{ (userInfo?.name || '') + (userInfo.age ? ', ' + userInfo.age :
                                                '') }}
                                        </div>
                                        <img class="w-20 h-20 mt-3" v-if="userInfo.isVip == 1"
                                            src="@/assets/icon/vip.png" alt="">
                                        <img v-if="userInfo.isFavorite == 1" class="status ml-10"
                                            src="@/assets/heart.png" alt="">
                                    </div>
                                    <div class="birthday" style="color: #999999;">Profile ID: {{ userId }} | {{ birthday
                                    }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="describe">
                        <div class="title">兴趣</div>
                        <div class="flex row wrap">
                            <div class="grid flex col middle around mt-10" v-for="(item, index) in interest"
                                :key="index">
                                <div class="mb-10">{{ item }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="describe">
                        <div class="title">基本信息</div>
                        <div class="basic-info-grid">
                            <div class="info-column">
                                <div class="item">
                                    <div class="label">居住在: </div>
                                    <div class="value">
                                        {{ userInfo.country ? userInfo.country + ' ' : '' }}
                                        {{ userInfo.city ? userInfo.city : '' }}
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="label">婚姻情况: </div>
                                    <div class="value">{{ $t('marriage.' + userInfo.marital_status) }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">英语水平: </div>
                                    <div class="value">{{ $t('english.' + userInfo.level_of_english) }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">掌握语言: </div>
                                    <div class="value">{{ userInfo.other_langs || '' }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">职业: </div>
                                    <div class="value">{{ userInfo.field_of_work }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">有孩子: </div>
                                    <div class="value" v-if="userInfo.count_children != null && userInfo.count_children !== ''">
                                        {{ userInfo.count_children }}
                                    </div>
                                </div>
                            </div>
                            <div class="info-column">
                                <div class="item">
                                    <div class="label">抽烟: </div>
                                    <div class="value">{{ $t('frequency.' + userInfo.smoking) }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">喝酒: </div>
                                    <div class="value">{{ $t('frequency.' + userInfo.drinking) }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">身高: </div>
                                    <div class="value">{{ userInfo.height || '' }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">体型: </div>
                                    <div class="value">{{ userInfo.body_type }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">眼睛: </div>
                                    <div class="value">{{ userInfo.color_eye }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">头发: </div>
                                    <div class="value">{{ userInfo.color_hair }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="describe">
                        <div class="title">关于我</div>
                        <div class="about-me-grid">
                            <div class="info-column">
                                <div class="item">
                                    <div class="flex row wrap value">
                                        <span class="trait-tag" v-for="(item, index) in userInfo.traits" :key="index">
                                            {{ item }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="about-me-description" v-if="userInfo.description">
                            <div class="description-text">{{ userInfo.description }}</div>
                        </div>
                    </div>
                    <div class="describe">
                        <div class="title">我在寻找</div>
                        <div class="looking-for-grid">
                            <div class="info-column">
                                <div class="item">
                                    <div class="label">年龄: </div>
                                    <!-- 
                                        只有preferences.age_from 显示preferences.age_from+
                                        只有preferences.age_to 显示preferences.age_to-
                                        如果preferences.age_to和preferences.age_from都存在，则显示preferences.age_from - preferences.age_to
                                    -->
                                    <div v-if="userInfo.age_from && !userInfo.age_to" class="value">
                                        {{ userInfo.age_from }} +
                                    </div>
                                    <div v-else-if="userInfo.age_to && !userInfo.age_from" class="value">
                                        {{ userInfo.age_to }} -
                                    </div>
                                    <div v-else-if="userInfo.age_from && userInfo.age_to" class="value">
                                        {{ userInfo.age_from }} - {{ userInfo.age_to }}
                                    </div>
                                    <div v-else class="value">不限</div>
                                </div>
                                <div class="item">
                                    <div class="label">性别: </div>
                                    <div class="value">{{ $t('sex.' + userInfo.gender) }}</div>
                                </div>
                            </div>
                            <div class="info-column">
                                <div class="item">
                                    <div class="label">性格: </div>
                                    <div class="value">{{ userInfo.pref_personality_type }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">目标: </div>
                                    <div class="flex row wrap value">
                                        <div class="shrink0 mr-10" v-for="(item, index) in userInfo.goal" :key="index">
                                            {{ item }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="looking-for-description" v-if="userInfo.looking_for">
                            <div class="description-text">{{ userInfo.looking_for }}</div>
                        </div>
                    </div>
                </div>
                <div class="photoInfo">
                    <div class="title">
                        <div class="item active">公开照片</div>
                    </div>
                    <ul class="photos" style="overflow:auto">
                        <li v-for="(item, index) in photoList" :key="index">
                            <ImagePreview :src="item.urlThumbnail" :preview-src="item.url"
                                :preview-src-list="showImgList(photoList)" :current-index="index">
                            </ImagePreview>
                        </li>
                    </ul>
                    <div class="w100 flex row center middle color-gray pd-y-10 fs-16" v-if="photoPageParams.loading">
                        加载中...
                    </div>
                    <div class="w100 flex row center middle color-gray pd-y-10 fs-16" v-if="photoPageParams.pageEnd">
                        ———— · 没有更多了 · ————
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import { userDetail } from '@/api/dialogue'
import ImagePreview from '@/components/imagePreview.vue';
import { getCountry } from '@/utils/country';
import { getConnectionsProfiles } from '@/api/talkytimes/personalData'
import { getPhotos } from '@/api/talkytimes/user'
import { getOccupation } from '@/api/talkytimes_user'
export default {
    props: {
        platformUserId: {
            type: [String, Number],
            default: ''
        },
        isRightCard: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ImagePreview
    },
    data() {
        return {
            userId: 0,
            userInfo: {},
            photoList: [],
            photoPageParams: {

            },
            visible: false,
            internalIsRightCard: false
        };
    },
    computed: {
        birthday() {
            if (JSON.stringify(this.userInfo) == '{}') return '';
            return this.userInfo?.birth_year + '年' + this.userInfo?.birth_month + '月' + this.userInfo?.birth_day + '日'
        },
        interest() {
            return this.userInfo?.hobbies || []
        },
    },
    watch: {
    },
    methods: {
        resetParams() {
            this.userInfo = {};
            this.photoList = []
            this.internalIsRightCard = false
            this.photoPageParams = {
                loading: false,
                pageEnd: false
            }
        },
        showImgList(list) {
            return list.map(item => item.url);
        },
        init(userId, isRightCard) {
            this.visible = true;
            this.userId = userId
            // 初始化参数
            this.resetParams()
            // 在resetParams之后设置isRightCard，避免被重置
            this.internalIsRightCard = isRightCard
            console.log('UserInfo组件 init - userId:', this.userId, '传入的isRightCard:', isRightCard, '内部internalIsRightCard:', this.internalIsRightCard)
            console.log('isRightCard 类型:', typeof isRightCard, '值:', isRightCard)
            
            // 先获取用户基本信息（所有情况都使用原有逻辑）
            this.getUserInfo(userId);
            
            // 如果是点击自己，额外获取职业信息
            if (isRightCard) {
                this.getMyOccupation(userId);
            }
            
            this.getPhotoList()
        },
        loadPhoto() {
            // 由于使用 getPhotos 接口一次性获取所有照片，不再需要分页加载
            // 此方法保留是为了兼容 infinite-scroll 指令
        },
        getPhotoList() {
            this.photoPageParams.loading = true
            console.log('getPhotoList - userId:', this.userId)

            // 统一使用 getPhotos 接口
            console.log('使用 getPhotos 接口')
            getPhotos(this.userId).then(res => {
                if (res.data && res.data.public) {
                    const photos = res.data.public.map(photo => ({
                        url: photo.url_original,
                        urlThumbnail: photo.url_xxl,
                        id: photo.id
                    }));
                    // 对于 getPhotos 接口，直接替换 photoList，因为是一次性获取所有照片
                    this.photoList = photos;
                    // getPhotos 接口一次性返回所有照片，所以设置 pageEnd 为 true
                    this.photoPageParams.pageEnd = true;
                }
            }).finally(() => {
                this.photoPageParams.loading = false
            })
        },
        closeClick() {
            this.resetParams();
            this.visible = false;
        },
        getCountry(code) {
            return getCountry(code);
        },
        
        // 获取自己的职业信息
        getMyOccupation(userId) {
            console.log('调用getOccupation接口，传入userId:', userId, '类型:', typeof userId);
            getOccupation({ userId: userId }).then(res => {
                console.log('获取自己的职业信息响应:', res);
                console.log('响应数据结构:', {
                    code: res.code,
                    data: res.data,
                    message: res.message
                });
                if (res.code === 200 && res.data) {
                    // 只更新职业信息，保持其他信息不变
                    const occupation = res.data.occupation || res.data.field_of_work || '';
                    console.log('设置职业信息:', occupation);
                    this.$set(this.userInfo, 'field_of_work', occupation);
                } else {
                    console.log('接口返回数据异常:', res);
                }
            }).catch(error => {
                console.error('获取职业信息失败:', error);
                // 如果获取失败，保持原有的职业信息不变
            });
        },
        
        // 获取对方用户信息（原有逻辑）
        getUserInfo(userId) {
            getConnectionsProfiles({ ids: [userId] }).then(res => {
                console.log('talkytimes用户信息:::::::::::::', res.data.profiles[0])
                const profiles = res.data.profiles[0];
                let userData = {
                    ...profiles,
                    ...(profiles.personal || {}),
                    ...(profiles.preferences || {}),
                    ...(profiles.splits || {})
                }
                delete userData.personal
                delete userData.preferences
                delete userData.splits

                this.userInfo = userData;
                console.log('userInfo', this.userInfo)
            });
        },
    },
    created() {

    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.userInfoHeaderImg {
    position: relative;
    left: -24px;
    top: -24px;
    width: calc(100% + 48px);
    height: 300px;
}

.el-dialog__close {
    transition: all 0.3s ease-in-out;
}

.el-dialog__close:hover {
    cursor: pointer;
    transform: rotate(180deg);
    transition: all 0.3s ease-in-out;
}

.card {
    height: 100%;
}

.userInfo {
    width: 100%;
    height: 100%;
    display: flex;

    .everyInfo {
        width: 35%;
        border-right: 1px solid #EEEEEE;
        display: flex;
        flex-direction: column;
        padding-right: 20px;
        max-height: 100%;
        min-height: 0;
        overflow-y: auto;

        .avatarInfo {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            .left {
                display: flex;
                align-items: center;

                .avatarAndStatus {
                    position: relative;

                    .avatar {
                        width: 80px;
                        height: 80px;
                        margin-right: 16px;
                        border-radius: 8px;
                    }

                    .icon {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background-color: #0CD85D;
                        position: absolute;
                        bottom: 2%;
                        right: 15%;

                        &.offline {
                            background-color: #999999;
                        }
                    }
                }


                .nameInfo {
                    height: 100%;
                    box-sizing: border-box;
                    padding: 12px 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .top {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        .info_title {
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;

                            .name {
                                font-weight: 500;
                                font-size: 24px;
                                color: #333333;
                                margin-right: 8px;
                                line-height: 28px;
                            }

                            .status {
                                width: 16px;
                                height: 16px;
                            }
                        }

                        .birthday {
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .address {
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                        }
                    }
                }
            }

            .right {
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                padding-top: 12px;
            }
        }

        .describe {
            margin-bottom: 30px;
            display: flex;
            flex-direction: column;

            .title {
                font-weight: 500;
                font-size: 22px;
                color: #333333;
                margin-bottom: 16px;
            }

            .grid {
                width: 33.3333333%;
            }

            .item {
                display: flex;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                margin-bottom: 12px;
                line-height: 22px;

                .label {
                    min-width: 100px;
                }

                .label+.value {
                    font-weight: bold;
                }

                .value {
                    flex: 1;
                }
            }

            .item:last-child {
                margin-bottom: 0;
            }

            .basic-info-grid {
                display: flex;
                gap: 20px;

                .info-column {
                    flex: 1;

                    .item {
                        margin-bottom: 8px;

                        .label {
                            min-width: 80px;
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .about-me-grid {
                display: flex;
                gap: 20px;

                .info-column {
                    flex: 1;

                    .item {
                        margin-bottom: 8px;

                        .label {
                            min-width: 80px;
                        }

                        .value {
                            .trait-tag {
                                display: inline-block;
                                padding: 6px 12px;
                                background-color: #f8f9fa;
                                color: #495057;
                                border-radius: 20px;
                                font-size: 14px;
                                font-weight: 400;
                                margin-right: 8px;
                                margin-bottom: 6px;
                                border: 1px solid #e9ecef;
                            }
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .about-me-description {
                margin-top: 16px;
                padding: 12px;
                background-color: #f8f9fa;
                border-radius: 8px;
                border-left: 4px solid #28a745;

                .description-text {
                    font-size: 14px;
                    line-height: 1.5;
                    color: #666666;
                    font-style: italic;
                }
            }

            .looking-for-grid {
                display: flex;
                gap: 20px;

                .info-column {
                    flex: 1;

                    .item {
                        margin-bottom: 8px;

                        .label {
                            min-width: 80px;
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .looking-for-description {
                margin-top: 16px;
                padding: 12px;
                background-color: #f8f9fa;
                border-radius: 8px;
                border-left: 4px solid #007bff;

                .description-text {
                    font-size: 14px;
                    line-height: 1.5;
                    color: #666666;
                    font-style: italic;
                }
            }
        }

        .describe:last-child {
            margin-bottom: 0;
        }
    }

    .photoInfo {
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 8px 18px;
        align-items: center;

        .title {
            display: flex;
            width: 342px;
            height: 48px;

            .item {
                width: 100%;
                height: 100%;
                font-weight: 400;
                font-size: 20px;
                line-height: 48px;
                color: #333333;
                text-align: center;
                background-color: #EEEEEE;
                border-radius: 8px;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.12);

                &.active {
                    font-weight: 400;
                    font-size: 20px;
                    color: #333333;
                    background-color: #EEEEEE;
                    border-radius: 8px;
                    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.12);
                }
            }
        }

        .photos {
            display: grid;
            width: 100%;
            height: 100%;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(3, 1fr);
            gap: 12px;
            margin-top: 20px;
            overflow-y: auto;
            max-height: calc(100% - 68px);
            box-sizing: border-box;
            padding-left: 40px;
        }

        .photos>div {
            width: 100%;
        }

        .photos .preview-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }
    }
}

.img_gray {
    filter: grayscale(100%) contrast(80%) brightness(110%);
}
</style>